import { Reducer } from "redux";

import {
    LIKE_INFO_FETCH_FAILURE,
    LIKE_INFO_FETCH_REQUEST,
    LIKE_INFO_FETCH_SUCCESS,
    LikeInfoFetchFailureAction,
    LikeInfoFetchRequestAction,
    LikeInfoFetchSuccessAction,
} from "@/mk2/apps/blogs/containers/LikeInfoPopup/LikeInfoPopup.actions";
import { tupdate } from "@/mk2/helpers/types";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

export interface LikeInfoPopupState {
    likerUserIds: number[];
    loadingState: LoadingState;
}

export const initialLikeInfoPopupState: LikeInfoPopupState = {
    likerUserIds: [],
    loadingState: LoadingState.INIT,
};

declare type LikeInfoPopupsReducerAction =
    | LikeInfoFetchRequestAction
    | LikeInfoFetchSuccessAction
    | LikeInfoFetchFailureAction;

export interface LikeInfoPopupsState {
    [entityTypeAndId: number]: LikeInfoPopupState;
}

const initialLikeInfoPopupsState: LikeInfoPopupsState = {};

const likeInfoPopupsReducer: Reducer<LikeInfoPopupsState, LikeInfoPopupsReducerAction> = (
    state = initialLikeInfoPopupsState,
    action,
) => {
    switch (action.type) {
        case LIKE_INFO_FETCH_REQUEST:
        case LIKE_INFO_FETCH_FAILURE: {
            const key = `${action.entityType}/${action.entityId}`;
            const likeState = state[key] || initialLikeInfoPopupState;

            return tupdate(state, {
                [key]: tupdate(likeState, {
                    loadingState: loadingState(likeState.loadingState, action),
                }),
            });
        }

        case LIKE_INFO_FETCH_SUCCESS: {
            const key = `${action.entityType}/${action.entityId}`;
            const likeState = state[key] || initialLikeInfoPopupState;

            return tupdate(state, {
                [key]: tupdate(likeState, {
                    likerUserIds: action.response.result.likers,
                    loadingState: loadingState(likeState.loadingState, action),
                }),
            });
        }

        default:
            return state;
    }
};

export default likeInfoPopupsReducer;
